import { Cluster } from '@cast/types';
import { getTimeAgo } from '@cast/utils';

export const formatClusterTags = (cluster: Cluster): string[] =>
  Object.entries(cluster.tags || {}).map(([key, value]) => `${key}: ${value}`);

export const formatClusterDashboardMetadata = (cluster: Cluster) => ({
  provider: cluster.providerType,
  providerLabel: cluster.providerType,
  region: cluster.region?.displayName || cluster.region?.name || '—',
  k8sVersion: cluster.kubernetesVersion || '—',
  connectedAt: cluster.createdAt ? getTimeAgo(cluster.createdAt) : '—',
  connectedTimestamp: cluster.createdAt || '—',
  clusterId: cluster.id,
  tags: formatClusterTags(cluster),
});
